<template>
  <div v-bind:class="{secondaryText: true, secondaryTextOneLine: oneline}">
    <img
      v-if="icon"
      :src="this.icon"
      alt=""
      class="secondaryTextIcon"/>
    <v-progress-circular
      v-if="progress"
      :value="progress"
      color="#2192F0"
      size="25"
      style="margin-right: 6px"
      width="3"
    ></v-progress-circular>
    <span v-html="html"></span>
  </div>
</template>

<script>

  export default {
    name: 'PageSecondaryText',
    props: ['text', 'oneline', 'icon', 'progress', 'displayProgress'],
    data() {
      return {
      }
    },

    computed: {
      html: {
        get: function () {
            return this.text;
          }
      }
    },

    methods: {

    },

    created() {
    }
  }
</script>

<style>
</style>
